import { useFormik } from 'formik';
import { useState } from 'react';
// mantine
import { Button, TagsInput, UnstyledButton } from '@mantine/core';
// components
import { Dropzone } from '@newo/ui-kit';
import FileItem from '@/components/FileItem';
// utils
import validationSchema from '@/pages/AKB/components/Toolbar/components/ImportAKBButton/components/ImportAKBForm/ImportAKBForm.schema.ts';

interface ImportAKBFormProps {
    onCancel: () => void;
    onSubmit: (formData: { file: File; labels: string[] }) => Promise<unknown>;
}

const ImportAKBForm = ({ onCancel, onSubmit }: ImportAKBFormProps) => {
    const [searchValue, setSearchValue] = useState('');
    const initialValues: { labels: string[]; file?: File } = {
        labels: [],
        file: undefined
    };
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (formData) => {
            if (formData.file) {
                onSubmit({
                    file: formData.file,
                    labels: searchValue
                        ? formData.labels.concat(searchValue)
                        : formData.labels
                });
                onCancel();
            }
        }
    });

    const handleLabelsChange = (value: string[]) => {
        formik.setFieldValue('labels', value);
    };

    return (
        <form
            autoComplete="off"
            className="flex flex-col gap-3"
            onSubmit={formik.handleSubmit}
        >
            {formik.values.file ? (
                <FileItem
                    name={formik.values.file.name}
                    size={formik.values.file.size}
                    onDelete={() => {
                        formik.setFieldValue('file', undefined);
                    }}
                />
            ) : (
                <Dropzone
                    accept={['json']}
                    text="Drag AKB file here or click to select file"
                    onDrop={(files) => {
                        formik.setFieldValue('file', files[0]);
                    }}
                />
            )}

            <TagsInput
                description="Press Enter to submit a label."
                label="Labels"
                placeholder="Enter label"
                searchValue={searchValue}
                size="sm"
                value={formik.values.labels}
                onChange={handleLabelsChange}
                onSearchChange={setSearchValue}
            />

            <div className="flex justify-between gap-2">
                <UnstyledButton
                    className="text-xs text-gray-6"
                    onClick={onCancel}
                >
                    Cancel
                </UnstyledButton>
                <Button
                    disabled={
                        (!formik.dirty && !searchValue) ||
                        !formik.isValid ||
                        formik.isSubmitting
                    }
                    size="xs"
                    type="submit"
                >
                    Import
                </Button>
            </div>
        </form>
    );
};

export default ImportAKBForm;
